/* global FB, sgData, SGEvent, SGAction, jQuery, localStorage, pageInformation */
import DebugConsole from './debug/debug-console';

(function ($) {
  /**
   * Default settings for the services.
   *
   * @type {Object}
   */
  var defaultOptions = {
    facebook: {
      loginEnabled: false,
      appId: null,
      advertisingId: null,
      language: 'en_US',
      userHasPassword: false,
      urls: {}
    },
    apple: {
      loginEnabled: false,
      urls: {}
    },
  };

  const debugConsole = new DebugConsole();

  /**
   * External Services class.
   * @constructor
   */
  function XTServices() {
    this.services = {};
    var _this = this;

    /**
     * Initiates the external services.
     *
     * @param {Object} opts The services options.
     */
    this.init = function (opts) {
      var options = $.extend(true, {}, defaultOptions, opts);

      // Maybe convert facebook appId to integer type.
      if (options.facebook.appId) {
        options.facebook.appId = parseInt(options.facebook.appId, 10);
      }

      initFacebookServices(options.facebook);
      initAppleServices(options.apple);
    };

    /**
     * Initiates the Facebook Services.
     *
     * @param {Object} options The facebook options.
     */
    function initFacebookServices(options) {
      if (!options.loginEnabled) {
        return;
      }

      _this.services.facebook = new Facebook(options);

      // Facebook Login
      _this.services.facebookLogin = new FacebookLogin(_this.services.facebook);
    }

    /**
     * Initiates the Apple Services.
     *
     * @param {Object} options The facebook options.
     */
    function initAppleServices(options) {
      if (!options.loginEnabled) {
        return;
      }

      // Facebook Login
      _this.services.appleLogin = new AppleLogin(options);
    }
  }

  /**
   * Facebook class.
   * Initiates the Facebook SDK.
   *
   * @param {Object} options The options from services class.
   * @constructor
   */
  function Facebook(options) {
    var version = 'v2.6';
    var appId = options.appId;
    var language = options.language || 'en_US';
    var userHasPassword = options.userHasPassword;
    var urls = options.urls;

    /**
     * Initialises the Facebook SDK when it is loaded asynchronous.
     * @returns {void}
     */
    window.fbAsyncInit = function () {
      FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: version,
      });
    };

    // Load the SDK.
    loadSDK();

    /**
     * Returns the ajax request url for the appropriate login type.
     * @param {string} type The login type.
     * @returns {string|null} The request url or null if type doesn't match.
     */
    this.getRequestUrl = function (type) {
      if (urls.hasOwnProperty(type)) {
        return urls[type];
      }
      return null;
    };

    /**
     * Returns true if the user has a password set
     * @returns {boolean} Info if the user has a password
     */
    this.getUserHasPassword = function () {
      return userHasPassword;
    };

    /**
     * Loads the Facebook JavaScript SDK.
     * @returns {void}
     */
    function loadSDK() {
      // Load SDK only for web.
      if (sgData.device.access === 'App') {
        return;
      }

      // Load the Facebook SDK.
      (function (d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/' + language + '/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
  }

  /**
   * Facebook Login class.
   *
   * @param {Facebook} facebook Instance of the Facebook Plugin
   * @constructor
   */
  function FacebookLogin(facebook) {
    enableButton();

    $(document).on('shopgateFramework.ui.contentUpdated', function () {
      enableButton();
    });

    // Append a click handler to the login button(s).
    $('.js-btn-merge-facebook')
      .off('click', handleMerge)
      .on('click', handleMerge);

    $('.js-btn-guest-login')
      .off('click', handleGuestLogin)
      .on('click', handleGuestLogin);

    var didSendCommand = false;
    var type;
    var password = null;
    var email = null;

    // Register to native event to handle the Facebook response.
    SGEvent.Broadcast.register('identityServiceDidLogIn');
    SGEvent.registerCallback('identityServiceDidLogIn', function (response) {
      if (!didSendCommand) {
        return;
      }

      if (response.success === true) {
        sendResponseToServer({
          accessToken: response.token,
        });
      }

      didSendCommand = false;
    });

    /**
     * Enables the Facebook Login button and appends the click handler.
     * @returns {void}
     */
    function enableButton() {
      var $loginButton = $('.js-btn-login-facebook');

      if (!$loginButton.length) {
        return;
      }

      var loginButtonType = $loginButton.data('type');

      if (loginButtonType === 'login' || facebook.getUserHasPassword()) {
        $loginButton
          .removeClass('disabled')
          .removeAttr('disabled');
      }

      // Append a click handler to the login button(s).
      $loginButton
        .off('click', handleLogin)
        .on('click', handleLogin);
    }

    /**
     * Handles the Facebook Login process.
     *
     * @param {Object} event The click event object.
     */
    function handleLogin(event) {
      event.preventDefault();

      // Check if FB object exists.
      if (sgData.device.access !== 'App' && typeof FB !== 'object') {
        console.error(new Error('Facebook SDK is not properly initiated!'));
        return;
      }

      determineType.apply(this);

      handleConnect();
    }

    /**
     * Handles the merging of shopgate account with facebook account.
     *
     * @param {Object} event The click event object.
     */
    function handleMerge(event) {
      event.preventDefault();

      if (sgData.device.access !== 'App' && typeof FB !== 'object') {
        console.error(new Error('Facebook SDK is not properly initiated!'));
        return;
      }

      determineType.apply(this);

      // Setting the password value;
      var $passwordfield = $('.js-password-merge-facebook');
      password = $passwordfield.val();

      // Setting the email value;
      var $emailfield = $('.js-email-merge-facebook');
      email = $emailfield.val();

      // For connecting with shopsystem account directly send request
      var sgConnect = $(this).data('sgConnect');
      if (sgConnect) {
        sendResponseToServer();
        return;
      }

      handleConnect();
    }

    /**
     * Send a data request to the server, indicating that the user wants to continue with a guest
     * checkout
     *
     * @param {Object} event The click event object.
     */
    function handleGuestLogin(event) {
      event.preventDefault();
      determineType.apply(this);

      var url = facebook.getRequestUrl(type);
      var requestData = { continueAsGuest: 1 };

      // Send all the information to the server.
      sendDataRequest(url, requestData);
    }

    /**
     * Determines the current action type based on
     * the buttons data-type attribute.
     * Needs the get the event handler context applied with .apply(this)
     * @returns {void}
     */
    function determineType() {
      var $button = $(this);
      type = $button.data('type');
    }

    /**
     * Handles the login process.
     * @returns {void}
     */
    function handleConnect() {
      if (sgData.device.access === 'App') {
        didSendCommand = true;
        SGAction.logInWithIdentityService({
          service: 'facebook',
          permissions: ['public_profile', 'email'],
        });
      } else {
        FB.login(function (response) {
          if (response.status === 'connected') {
            sendResponseToServer(response.authResponse);
          }
        }, { scope: 'public_profile, email' });
      }
    }

    /**
     * Sends the Facebook Login request result to the server.
     *
     * @param {Object} [responseParam] The facebook authResponse object.
     */
    function sendResponseToServer(responseParam) {
      var response = responseParam || {};

      var url = facebook.getRequestUrl(type);
      var requestData = {};

      if (!url) {
        console.error(new Error('No request url provided for login process with Facebook!'));
        return;
      }

      requestData.provider = 'facebook';
      requestData.type = type;

      if (type !== 'disconnect') {
        requestData.accessToken = response.accessToken || null;

        if (type === 'merge') {
          if (password !== null) {
            requestData.password = password;
          }

          if (email !== null) {
            requestData.email = email;
          }
        }
      }

      sendDataRequest(url, requestData);
    }

    /**
     * Sends a data-request to the server
     *
     * @param {string} url         Server endpoint to invoke
     * @param {Object} requestData Post data in JSON format
     */
    function sendDataRequest(url, requestData) {
      const isApp = sgData.device.access === 'App';

      // Send all the information to the server.
      $.shopgate.ajax({
        url,
        type: 'POST',
        data: {
          ...requestData,
          ...(isApp ? { sourceTab: pageInformation.tab } : {}),
        },
        beforeSend: function () {
          $(document).trigger('shopgateFramework.waitingIndicator.show');
        },
        success: function (responseData) {
          // If the app provides a invalid token, run logout command
          // and try to logout again.
          if (!responseData.success && isApp) {
            SGAction.logOutFromIdentityService({ service: 'facebook' });
          }
        },
        error: function () {
          console.warn(arguments);
        },
      });
    }
  }

  /**
   * The AppleLogin class
   */
  class AppleLogin {
    /**
     * @param {Object} options Class options.
     */
    constructor(options) {
      this.userIdentifierKey = 'apple_user_identifier';
      this.options = options;

      this.enableAppleButton();

      $(document).on('shopgateFramework.ui.contentUpdated', () => {
        this.enableAppleButton();
      });

      // Append a click handler to the login button(s).
      $('.js-btn-merge-apple')
        .off('click', this.handleAppleMerge)
        .on('click', this.handleAppleMerge);

      $('.js-btn-guest-login.apple')
        .off('click', this.handleAppleGuestLogin)
        .on('click', this.handleAppleGuestLogin);

      /**
       * Remove the apple user identifier for every button other tha apple which
       * can be used to login / register
       */
      $('.js-login, .js-register, .login-buttons .btn-login:not(.js-btn-login-apple)')
        .off('click', this.removeUserIdentifier)
        .on('click', this.removeUserIdentifier);

      // Register to native event to handle the Apple response.
      SGEvent.Broadcast.register(
        'signInWithAppleAuthorizationResponse',
        'signInWithAppleCredentialStateResponse',
        'userLoggedIn',
        'userLoggedOut',
        'applicationWillEnterForeground'
      );

      SGEvent.registerCallback('viewWillAppear', () => {
        /**
         * On app start, or when the apps comes back to the foreground, we need to check, if the
         * apple authorization is still active. To guarantee that the logic only runs once,
         * it's only executed within the menu bar.
         */
        if (pageInformation && pageInformation.pageId === 'set_menu_bar' && pageInformation.initialAppearance) {
          this.checkCredentialState();
        }
      })
      .registerCallback('applicationWillEnterForeground', () => {
        if (pageInformation && pageInformation.pageId === 'set_menu_bar') {
          this.checkCredentialState();
        }
      })
      .registerCallback('userLoggedIn', () => {
        // After a user logged in, the temporary identifier can be used for credential check
        this.convertTempUserIdentifier();
      })
      .registerCallback('userLoggedOut', () => {
        this.removeUserIdentifier();
      })
      .registerCallback('signInWithAppleCredentialStateResponse', (error, response) => {
        // Log the user out when the app is not authorized anymore
        if (response !== 'authorized') {
          $.shopgate.ajax({
            url: this.options.urls.logout,
            beforeSend: () => {
              $(document).trigger('shopgateFramework.waitingIndicator.show');
            },
          });
        }
      });
    }

    /**
     * Enables the Apple button
     */
    enableAppleButton = () => {
      const $loginButton = $('.js-btn-login-apple');

      if (!$loginButton.length) {
        return;
      }

      $loginButton
        .removeClass('disabled')
        .removeAttr('disabled')
        .off('click', this.handleAppleLogin)
        .on('click', this.handleAppleLogin);
    }

    /**
     * Handles the Apple Login process.
     *
     * @param {Event} event The click event object.
     */
    startAppleLogin = (event) => {
      event.preventDefault();

      const $button = $(event.currentTarget);
      if ($button.hasClass('disabled')) {
        return;
      }

      $button.attr('disabled', 'disabled').addClass('disabled');
      SGAction.signInWithAppleAuthorizationRequest();
    }

    /**
     * Initiate the process for the Apple login
     * @param {Object} event Event payload from the triggering button
     */
    handleAppleLogin = (event) => {
      event.preventDefault();
      this.prepareAuthorizationHandler((response) => {
        this.sendAppleDataRequest('login', {
          provider: 'apple',
          type: 'login',
          accessToken: JSON.stringify(response),
        });
      });

      this.startAppleLogin(event);
    }

    /**
     * Initiate the process for the credential merge
     * @param {Object} event Event payload from the triggering button
     */
    handleAppleMerge = (event) => {
      event.preventDefault();

      const $button = $(event.currentTarget);

      // CONNECT (Engage) flow
      if ($button.data('sgConnect')) {
        this.sendAppleDataRequest('merge', {
          email: $('.js-email-merge-apple'),
          password: $('.js-password-merge-apple'),
        });

        return;
      }

      this.prepareAuthorizationHandler((response) => {
        this.sendAppleDataRequest('merge', {
          email: $('.js-email-merge-apple').val(),
          password: $('.js-password-merge-apple').val(),
          accessToken: JSON.stringify(response),
        });
      });

      this.startAppleLogin(event);
    }

    /**
     * Initiate the process for the apple guest login
     * @param {Object} event Event payload from the triggering button
     */
    handleAppleGuestLogin = (event) => {
      event.preventDefault();

      // Send all the information to the server.
      this.sendAppleDataRequest('merge', { continueAsGuest: 1 });
    }

    /**
     * Prepares an app event handler for the signInWithAppleAuthorizationResponse event
     * @param {Function} callback Invoked after the authorization response came in
     */
    prepareAuthorizationHandler(callback) {
      SGEvent.unregisterCallback('signInWithAppleAuthorizationResponse');
      SGEvent.registerCallback('signInWithAppleAuthorizationResponse', (error, response) => {
        if (error) {
          debugConsole.warn('signInWithAppleAuthorizationResponse error', error);
          this.enableAppleButton();
          return;
        }

        if (!response) {
          debugConsole.warn('signInWithAppleAuthorizationResponse empty response');
          this.enableAppleButton();
          return;
        }

        callback(response);
      });
    }

    /**
     * Sends the data request for sign in with apple
     * @param {string} type Type of the request
     * @param {Object} requestData Request data
     */
    sendAppleDataRequest(type, requestData) {
      if (!this.options.urls[type]) {
        debugConsole.error(new Error('No request url provided for login process with Apple!'));
        return;
      }

      // Send all the information to the server.
      $.shopgate.ajax({
        url: this.options.urls[type],
        type: 'POST',
        data: {
          ...requestData,
          sourceTab: pageInformation.tab,
        },
        beforeSend: () => {
          $(document).trigger('shopgateFramework.waitingIndicator.show');
        },
        success: () => {
          this.enableAppleButton();

          const { accessToken } = requestData || {};

          if (accessToken) {
            const { userIdentifier } = JSON.parse(accessToken);
            this.setTempUserIdentifier(userIdentifier, true);
          }
        },
        error: (...args) => {
          this.enableAppleButton();
          debugConsole.warn(args);
        },
      });
    }

    /**
     * Puts the apple user identifier into the local storage
     * @param {string} token The user identifier
     */
    setTempUserIdentifier = (token) => {
      localStorage.setItem(this.userIdentifierKey, `temp_${token}`);
    }

    /**
     * Returns the apple user identifier from the local storage when available.
     * @returns {string|null}
     */
    getUserIdentifier = () => {
      let result = null;
      const userIdentifier = localStorage.getItem(this.userIdentifierKey);

      if (userIdentifier && userIdentifier.indexOf('temp_') === -1) {
        result = userIdentifier;
      }

      return result;
    }

    /**
     * Converts a temporary local storage user identifier to stable one
     */
    convertTempUserIdentifier = () => {
      const userIdentifier = localStorage.getItem(this.userIdentifierKey);

      if (userIdentifier && userIdentifier.indexOf('temp_') === 0) {
        localStorage.setItem(this.userIdentifierKey, userIdentifier.replace('temp_', ''));
      }
    }

    /**
     * Removes the apple user identifier from the local storage
     */
    removeUserIdentifier = () => {
      window.removedTwo = true;
      localStorage.removeItem(this.userIdentifierKey);
    }

    /**
     * Checks the sign in with apple credential state
     */
    checkCredentialState = () => {
      const userIdentifier = this.getUserIdentifier();

      if (userIdentifier) {
        SGEvent.unregisterCallback('signInWithAppleCredentialStateResponse');
        SGEvent.registerCallback('signInWithAppleCredentialStateResponse', (error, response) => {
          if (response !== 'authorized') {
            $.shopgate.ajax({
              url: this.options.urls.logout,
              beforeSend: () => {
                $(document).trigger('shopgateFramework.waitingIndicator.show');
              },
            });
          }
        });

        SGAction.signInWithAppleCredentialStateRequest({ userIdentifier });
      }
    }
  }

  window.xtServices = new XTServices();
})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/xt-services.js